import { useFormikContext } from 'formik'

import type { ReactElement } from 'react'
import type { IEngineFormValues, IVersionEngineFormValues } from '~/types/arbitration'

import PlacementCard from '../PlacementCard'

import './styles.scss'

interface Props {
  navigationGraphOptions: IOption[]
  onDelete: (index: number) => void
  placementOptions: IOption[]
  search: string
}

const EnginePlacements = ({ navigationGraphOptions, onDelete, placementOptions, search }: Props): ReactElement => {
  const { values } = useFormikContext<IEngineFormValues | IVersionEngineFormValues>()

  return (
    <div className="engine-placements-container">
      {values.placements.map(({ placement }, index) =>
        !placement || placement?.label.includes(search) ? (
          <div className="engine-placements-container__row" key={index}>
            <PlacementCard
              navigationGraphName={`placements[${index}].navigationGraph`}
              navigationGraphOptions={navigationGraphOptions}
              onDelete={() => onDelete(index)}
              placementName={`placements[${index}].placement`}
              placementOptions={placementOptions}
            />
          </div>
        ) : null
      )}
    </div>
  )
}

export default EnginePlacements
